import React from 'react';
import { Link } from 'react-router-dom';

const Breadcrumb = ({ title, submenu, LinkText }) => {
  const levels = [title || LinkText, submenu]
    .filter(Boolean)
    .flatMap((value) => value.split('/').map((level) => level.trim()).filter(Boolean));

  return (
    <div className="breadcrumb-bar">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-md-12 col-12">
            <nav aria-label="Fil d’Ariane" className="page-breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/apps">Apps</Link></li>
                {levels.map((level, index) => (
                  <li
                    className={`breadcrumb-item${index === levels.length - 1 ? ' active' : ''}`}
                    aria-current={index === levels.length - 1 ? 'page' : undefined}
                    key={`${level}-${index}`}
                  >
                    {level}
                  </li>
                ))}
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
